// Project data — Unsplash placeholder images themed around luxury interiors
export const projects = [
    {
        id: "modern-luxury-villa",
        name: "The Banjara Villa",
        type: "Luxury Villas",
        category: "Luxury Villas",
        city: "Banjara Hills, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?auto=format&fit=crop&w=1400&q=80",
        size: "lg",
        videoId: "xjFeKB6rWfw",
        description: "A modern luxury villa featuring a curated balance of warm timber, marble, and brushed brass accents.",
    },
    {
        id: "contemporary-home",
        name: "Jubilee Heights Residence",
        type: "Residential",
        category: "Residential",
        city: "Jubilee Hills, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1400&q=80",
        size: "md",
        videoId: "ETAFXBo5Y8I",
        description: "A contemporary 4BHK home rooted in restraint — soft greys, fluted oak, and sculptural lighting.",
    },
    {
        id: "kitchen-marble",
        name: "The Marble Kitchen",
        type: "Modular Kitchen",
        category: "Modular Kitchen",
        city: "Gachibowli, Hyderabad",
        year: "2023",
        image: "https://images.unsplash.com/photo-1722605090433-41d1183a792d?auto=format&fit=crop&w=1400&q=80",
        size: "md",
        description: "Italian marble countertops, custom champagne hardware, and chef-grade appliances.",
    },
    {
        id: "office-lobby",
        name: "Cyberpark Headquarters",
        type: "Commercial",
        category: "Commercial",
        city: "HITEC City, Hyderabad",
        year: "2023",
        image: "https://images.unsplash.com/photo-1758691736933-bb0f88fe2e0c?auto=format&fit=crop&w=1400&q=80",
        size: "lg",
        description: "A 22,000 sq.ft corporate headquarters designed as a hospitality-led workplace.",
    },
    {
        id: "luxury-bedroom",
        name: "Suite Nº 7",
        type: "Residential",
        category: "Residential",
        city: "Kondapur, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1400&q=80",
        size: "sm",
        description: "Master suite with hand-tufted wool, oak flooring and heritage brass detailing.",
    },
    {
        id: "villa-living",
        name: "The Cantonment House",
        type: "Luxury Villas",
        category: "Luxury Villas",
        city: "Secunderabad, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1618219740975-d40978bb7378?auto=format&fit=crop&w=1400&q=80",
        size: "md",
        description: "A 6,800 sq.ft heritage-meets-modern villa across three storeys.",
    },
    {
        id: "boutique-restaurant",
        name: "Maison Champa",
        type: "Commercial",
        category: "Commercial",
        city: "Banjara Hills, Hyderabad",
        year: "2023",
        image: "https://images.unsplash.com/photo-1559329007-40df8a9345d8?auto=format&fit=crop&w=1400&q=80",
        size: "sm",
        description: "Boutique restaurant interiors with mood lighting and bespoke joinery.",
    },
    {
        id: "modern-bath",
        name: "The Stone Bath",
        type: "Residential",
        category: "Residential",
        city: "Madhapur, Hyderabad",
        year: "2023",
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
        size: "md",
        description: "Spa-grade master bath finished in travertine and antique brass.",
    },
    {
        id: "minimal-kitchen",
        name: "Atelier Kitchen",
        type: "Modular Kitchen",
        category: "Modular Kitchen",
        city: "Tellapur, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80",
        size: "sm",
        description: "Minimalist German modular kitchen with handle-less cabinetry.",
    },
    {
        id: "penthouse",
        name: "Skyline Penthouse",
        type: "Luxury Villas",
        category: "Luxury Villas",
        city: "Financial District, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=80",
        size: "lg",
        description: "12,000 sq.ft duplex penthouse with double-height living and rooftop terrace.",
    },
    {
        id: "boutique-office",
        name: "Studio One Office",
        type: "Commercial",
        category: "Commercial",
        city: "Kokapet, Hyderabad",
        year: "2023",
        image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
        size: "md",
        description: "An elevated boutique workspace for a creative agency.",
    },
    {
        id: "family-living",
        name: "The Family House",
        type: "Residential",
        category: "Residential",
        city: "Manikonda, Hyderabad",
        year: "2024",
        image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=1400&q=80",
        size: "md",
        description: "A warm family home blending classical mouldings with modern materiality.",
    },
];

export const featuredProjects = projects.slice(0, 6);

export const projectCategories = [
    "All",
    "Residential",
    "Commercial",
    "Modular Kitchen",
    "Luxury Villas",
];
